import {
  useGetApiQuoteApiLanguage,
  usePutApiQuoteApiLanguageWithJson,
} from "../../../openapi/backendApi";
import { languageInit } from "../../../tools/helper";
import { LanguageSelect } from "../LanguageSelect/LanguageSelect";

import { JSX, useState } from "react";

import { VMLanguages, useLanguage } from "@4pace-cpq/core";
import { CircularProgress } from "@mui/material";
import { useSearch } from "@tanstack/react-router";

export function LanguageSelectContainer(): JSX.Element {
  const { language: searchLanguage } = useSearch({ strict: false });
  const { languages, setLanguageById, selectedLanguage } = useLanguage();
  const { mutate: setQuoteLanguage } = usePutApiQuoteApiLanguageWithJson();
  const { data: quoteLanguage, isFetching } = useGetApiQuoteApiLanguage();
  const [status, setStatus] = useState<string>("init");

  const handleSetLanguageById = (nextLanguage: VMLanguages): void => {
    if (selectedLanguage?.languageCode !== nextLanguage.languageCode) {
      setLanguageById(nextLanguage.id);
    }
  };

  if (isFetching) {
    return (
      <>
        <CircularProgress size="1em" />
      </>
    );
  }

  if (status === "init" || status === "quoteLangChange") {
    const nextAppLanguage = languageInit({
      searchLanguage,
      quoteLanguage: quoteLanguage?.data.string,
      i18nLanguage: selectedLanguage?.languageCode ?? null,
      languages,
      callback: (newStatus: string) => {
        setStatus(newStatus);
      },
    });
    if (nextAppLanguage) {
      handleSetLanguageById(nextAppLanguage);
    }
  }

  function handleLanguageChange(languageCode: string | undefined): void {
    if (typeof languageCode !== "string") {
      console.error(
        "handleLanguageChange: Invalid language code",
        languageCode,
      );
      return;
    }
    let languageData: VMLanguages | undefined = languages?.find(
      (lang) => lang.languageCode === languageCode,
    );
    if (!languageData) {
      languageData = languages?.find(
        (lang) =>
          lang.languageCode?.split("-")[0] === languageCode?.split("-")[0],
      );
    }
    if (!languageData?.languageCode) {
      console.error(
        "handleLanguageChange: Language code not in CPQ languages",
        languageCode,
        languages,
      );
      return;
    }
    setQuoteLanguage({ data: { languageCode: languageData.languageCode } });

    handleSetLanguageById(languageData);
  }

  return languages ? (
    <>
      <LanguageSelect
        languages={languages}
        onChange={(selectedLanguageId) => {
          handleLanguageChange(selectedLanguageId);
        }}
      />
    </>
  ) : (
    <></>
  );
}

export default LanguageSelectContainer;
